import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateUserMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  first_name: Types.Scalars['String']['input'];
  last_name: Types.Scalars['String']['input'];
  email: Types.Scalars['String']['input'];
  phone_number?: Types.InputMaybe<Types.Scalars['String']['input']>;
  workspace_id?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CreateUserMutation = { __typename?: 'mutation_root', create_user?: { __typename?: 'CreateUserOutput', success: boolean, user_id?: string | null, error?: string | null, handover_id?: string | null, createdUser?: { __typename?: 'users_ActionType', id: string, created_at?: any | null, email: string, first_name: string, is_admin?: boolean | null, last_name: string, last_seen?: any | null, phone_number?: string | null, profile_photo?: string | null, workspace_id?: any | null, role?: string | null } | null } | null };


export const CreateUserDocument = gql`
    mutation createUser($id: String!, $first_name: String!, $last_name: String!, $email: String!, $phone_number: String, $workspace_id: String) {
  create_user(
    id: $id
    first_name: $first_name
    last_name: $last_name
    email: $email
    phone_number: $phone_number
    workspace_id: $workspace_id
  ) {
    success
    user_id
    error
    createdUser {
      id
      created_at
      email
      first_name
      is_admin
      last_name
      last_seen
      phone_number
      profile_photo
      workspace_id
      role
    }
    handover_id
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      first_name: // value for 'first_name'
 *      last_name: // value for 'last_name'
 *      email: // value for 'email'
 *      phone_number: // value for 'phone_number'
 *      workspace_id: // value for 'workspace_id'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;